import { render, staticRenderFns } from "./AddAbonado.vue?vue&type=template&id=24c62d90"
import script from "./AddAbonado.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAbonado.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports